import { render, staticRenderFns } from "./FieldTextareaReply.vue?vue&type=template&id=2f2c1712&scoped=true"
import script from "./FieldTextareaReply.vue?vue&type=script&lang=js"
export * from "./FieldTextareaReply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c1712",
  null
  
)

export default component.exports